import React from 'react';
import {actions} from 'react-redux-form';
import {toast} from 'react-toastify';
import irelandApi from '../irelandApi';
import store, {history} from '../store';
import ToastMessage from '../components/common/toast-message';

export const updateMyPassword = (payload, redirectUrl) => {
  const data = {
    user: {...payload},
  };
  return irelandApi.put('/api/users', data)
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Password changed successfully"/>);
      history.push(redirectUrl);
      store.dispatch(actions.reset('deep.updatePw'));
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save"/>);
      store.dispatch(actions.resetValidity('deep.updatePw.user'));
      const errorData = {
        ...error.response.data.errors
      };
      return Promise.reject(errorData);
    });
};
export const adminUpdateMyPassword = (payload) => {
  const data = {
    user: {...payload},
  };
  return irelandApi.put('/api/admin/users', data)
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Password changed successfully"/>);
      history.push('/admin/my-profile');
      store.dispatch(actions.reset('deep.updatePw'));
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save"/>);
      store.dispatch(actions.resetValidity('deep.updatePw.user'));
      const errorData = {
        ...error.response.data.errors
      };
      return Promise.reject(errorData);
    });
};



// WEBPACK FOOTER //
// ./src/actions/update-password.js